import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import ContentDialog from '@/Pages/Sessions/uiComponents/ContentDialog/ContentDialog';
import RenameTitleModal from '@/Pages/Sessions/AssetsTable/RenameTitleModal';
import { useClipTitleRename } from '@/hooks/useClipTitleRename';

const ClipTitlePopup = () => {
  const { clipData } = useClipsContext();
  const { renamingClip, onSaveNewTitle, closeRenamingClipDialog, setRenamingClip } = useClipTitleRename();
  return (
    <>
      <div
        className="max-w-60 truncate rounded-lg p-2 text-sm text-slate-600 hover:bg-slate-200"
        title={clipData.title}
        onClick={() => setRenamingClip(clipData)}
      >
        {clipData.title}
      </div>
      {renamingClip ? (
        <ContentDialog isOpen={!!renamingClip} setIsOpen={closeRenamingClipDialog} title="Rename" size="xsmall">
          <RenameTitleModal
            existingTitle={renamingClip.title}
            onSubmit={onSaveNewTitle}
            onClose={closeRenamingClipDialog}
          />
        </ContentDialog>
      ) : null}
    </>
  );
};

export default ClipTitlePopup;
